export var SvgIconType;
(function (SvgIconType) {
    SvgIconType["Add"] = "add";
    SvgIconType["VisibleData"] = "visibleData";
    SvgIconType["InvisibleData"] = "invisibleData";
    SvgIconType["Copy"] = "copy";
    SvgIconType["Overlay"] = "overlayButton";
    SvgIconType["Indicator"] = "indicatorButton";
    SvgIconType["Tools"] = "toolsButton";
    SvgIconType["OrderEntry"] = "orderEntryButton";
    SvgIconType["MouseTrade"] = "mouseTradeButton";
    SvgIconType["ObjectManager"] = "objectManagerButton";
    SvgIconType["Checkbox"] = "checkbox";
    SvgIconType["ArrowDown"] = "arrowDown";
    SvgIconType["ArrowUp"] = "arrowUp";
    SvgIconType["ArrowRight"] = "arrowRight";
    SvgIconType["Edit"] = "edit";
    SvgIconType["Close"] = "closeCrossBtn";
    SvgIconType["MenuError"] = "menuError";
    SvgIconType["UpdateNotificationArrow"] = "updateNotificationArrow";
    SvgIconType["Search"] = "search";
    SvgIconType["Beta"] = "beta";
    SvgIconType["InstrumentLookup"] = "instrumentLookup";
    SvgIconType["PositionSizing"] = "positionSizing";
    SvgIconType["TrailingStop"] = "trailingStop";
})(SvgIconType || (SvgIconType = {}));
